module.exports = __webpack_public_path__ + "static/media/ic_user_avatar.50c151c8.png";